import { inlineToolbarTabs } from '../../inline';
export var tableBlock = {
  inlineToolbarTabs: inlineToolbarTabs,
  isEditable: false
};